<template>
  <div id="centro-sub-tab">
    <v-layout align-center justify-center>
      <v-flex lg12>
        <template>
          <v-tabs v-model="active_tab">
            <v-tabs-slider :key="index" color="blue"></v-tabs-slider>
            <v-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="selected(tab)"
              >{{ tab }}</v-tab
            >
            <v-tabs-items>
              <!-- TAB DE ACOPIO -->
              <v-card :key="cardAcopio" flat v-if="tabSelected == 'Acopio'">
                <centro-tab
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></centro-tab>
              </v-card>
              <!-- TAB DE OPERACION -->
              <v-card
                :key="cardOperacion"
                flat
                v-if="tabSelected == 'Operacion'"
              >
                <centro-tab
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></centro-tab>
              </v-card>
              <!-- TAB DE CAPACITACION -->
              <v-card
                :key="cardCapacitacion"
                flat
                v-if="tabSelected == 'Capacitacion'"
              >
                <centro-tab
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></centro-tab>
              </v-card>
            </v-tabs-items>
          </v-tabs>
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import CentroTab from "@/modules/aplicacion/views/centros/Centro.vue";
// import OperacionCentroTab from "@/modules/aplicacion/views/centros/Centro.vue";
// import CapacitacionCentroTab from "@/modules/aplicacion/views/centros/Centro.vue";

export default {
  name: "centro-sub-tab",

  components: {
    CentroTab,
    // OperacionCentroTab,
    // CapacitacionCentroTab,
  },
  props: {},
  data: () => ({
    text: "En construccion",
    proveedor: {},
    tabs: ["Acopio", "Operacion", "Capacitacion"],
    contratoId: "",
    tabSelected: "",
    activeTab: "",
    index: "",
    active_tab: "",

    cardAcopio: 0,
    cardOperacion: 10,
    cardCapacitacion: 20,
  }),
  mounted() {},
  created() {
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.proceso = this.$store.getters.proSelectedStored;

    if (
      !this.$route.params.contratoId ||
      this.$route.params.contratoId == null ||
      this.$route.params.contratoId == ""
    ) {
      this.contratoId = this.$store.getters.contratoStored;
    } else {
      this.contratoId = this.$route.params.contratoId;
    }
    this.loadSelected();
    this.active_tab = this.tabs.indexOf(
      this.$store.getters.subTabSelectedStored
    );
  },
  methods: {
    loadSelected() {
      this.tabSelected = this.$store.getters.subTabSelectedStored;
    },
    selected(tab) {
      this.tabSelected = tab;
      this.$store.commit("sub_tab_state", tab);
      if (this.tabSelected == "Acopio") {
        this.reloadAcopio();
      }
      if (this.tabSelected == "Operacion") {
        this.reloadOperacion();
      }
      if (this.tabSelected == "Capacitacion") {
        this.reloadCapacitacion();
      }
    },
    reloadAcopio() {
      this.cardAcopio += 1;
    },

    reloadOperacion() {
      this.cardOperacion += 11;
    },

    reloadCapacitacion() {
      this.cardCapacitacion += 21;
    },
  },
};
</script>
